<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Atenciones Médicas</h4>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue;cursor:pointer"
            @click="showModalHelp = true">help</span>
        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp">
      <AyudaFacturacion />
    </Modal>
    <hr>

    <!-- Filtro de estado -->
    <div class="mb-3">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="estadoAtencion" id="finalizada"
          value="FINALIZADA" v-model="seleccionEstado" @change="getDataTodos">
        <label class="form-check-label" for="finalizada">Atenciones Finalizadas</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="estadoAtencion" id="planillaGenerada"
          value="FACTURADA" v-model="seleccionEstado" @change="getDataTodos">
        <label class="form-check-label" for="planillaGenerada">Atenciones Facturadas</label>
      </div>
    </div>

    <DataTable
      :data="atencions"
      :columns="columnas"
      idField="idAtencion"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarInfo="false"
      :mostrarEditar="false"
      :mostrarVer="true"
      :mostrarEliminar="false"
      :mostrarBotonExcel="true"
      @refresh="getDataTodos"
      @view="({ idAtencion }) => verAtencion(idAtencion)"
    >
      <!-- Columna fecha formateada -->
      <template #cell-fechaCita="{ row }">
        {{ getFormattedDate(row.fechaCita, 'DD/MM/YYYY') }}
      </template>
    </DataTable>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import AyudaFacturacion from '@/views/ayuda/AyudaFacturacion.vue'
import { decodificarTipoCita } from '@/modules/decode.js'
import dateFormat from '@/modules/dateFormat.js'
import { exportToCsv } from '@/modules/exportDatos.js'
import api from '@/services/api'

export default {
  props: {
    p_idPersona: { type: String, required: true },
  },

  components: { Layout, Footer, DataTable, AyudaFacturacion },

  data() {
    return {
      atencions: [],
      seleccionEstado: 'FINALIZADA',
      showModalHelp: false,
/*
      columnas: [
        { field: 'numero',            label: 'Número' },
        { field: 'fechaCita',         label: 'Fecha Cita' },   // render via slot
        { field: 'horaDesde',         label: 'Hora' },
        { field: 'documentoPaciente', label: 'Cédula' },
        { field: 'nombrePaciente',    label: 'Nombre Paciente' },
        { field: 'nombreEspecialidad',label: 'Especialidad' },
        { field: 'estadoAtencion',    label: 'Estado Atención' },
      ],
*/
    }
  },

computed: {
  columnas() {
    return [
      { field: 'numero',             label: 'Número' },
      { field: 'fechaCita',          label: 'Fecha Cita' },
      { field: 'horaDesde',          label: 'Hora' },
      { field: 'documentoPaciente',  label: 'Cédula' },
      { field: 'nombrePaciente',     label: 'Nombre Paciente' },
      {
        field:         'nombreEspecialidad',
        label:         'Especialidad',
        filterType:    'select',
        filterOptions: [...new Set(this.atencions.map(a => a.nombreEspecialidad).filter(Boolean))]
                         .sort()
                         .map(v => ({ value: v, label: v })),
      },
/*
      {
        field:         'estadoAtencion',
        label:         'Estado Atención',
        filterType:    'select',
        filterOptions: [...new Set(this.atencions.map(a => a.estadoAtencion).filter(Boolean))]
                         .sort()
                         .map(v => ({ value: v, label: v })),
      },
*/
    ]
  }
},

  mounted() {
    this.getDataTodos()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    descTipoCita(codigo) {
      return decodificarTipoCita(codigo)
    },

    getDataTodos() {
      api.get(`/vwatencions/empresa-estadoatencion/${window.sessionStorage.getItem('idEmpresa')}/${this.seleccionEstado}`)
        .then(r => { this.atencions = r.data.reverse() })
        .catch(e => console.error('Error cargando atenciones:', e))
    },

    verAtencion(idAtencion) {
      this.$router.push('/atencion_atenciondet/' + idAtencion)
    },


    downloadDataAsCsv() {
      const headers = [
        'idAtencion', 'idPersona', 'idMedico', 'idCita', 'idEmpresa',
        'motivo', 'tipo', 'observacion', 'fechaCita', 'horaDesde',
        'horaHasta', 'fechaReg', 'fechaAct', 'estado', 'citaFechaReg',
        'personaFechaReg', 'nombrePaciente', 'documentoPaciente',
        'nombreMedico', 'documentoMedico', 'nombreEspecialidad',
      ]
      exportToCsv('atenciones.csv', this.atencions, headers)
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>